export default "__VITE_ASSET__D8Zxn7aw__"